import { Injectable, autobind } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

import {
  AreaList,
  ContestDetailInfoList,
  UserCreationActivityType,
} from '@/types';

import { SHOW_BRAND } from '@/utils';

import ActivityDefaultBannerImage from '@/assets/image/home/activity-banner-default.png';
import EventBusItemDetail from '@/eventBus/itemDetail';

@Injectable()
export class ActivityService {
  public activityType!: number;
  public activityId!: number;
  public contestId!: number;

  public provinceId!: number; // 当前选中的省份
  public cityId!: number; // 当前选中的城市
  public areaList: AreaList = []; // 省份和城市的下拉框数据

  public pageNum = 1;
  public pageSize = 6;
  public total = -1;

  public bannerImage = '';

  public activityTypeList!: UserCreationActivityType[];

  // 没有指定活动类型，需要显示活动类型tab组件
  public isActivityList = false;
  public activityList: ContestDetailInfoList = [];

  constructor(public daoService: DaoService) {}

  public setActivityType(type: number) {
    this.activityType = type;
  }
  public setActivityId(id: number) {
    this.activityId = id;
  }
  public setContestId(id: number) {
    this.contestId = id;
  }
  public setProvinceId(id: number) {
    this.provinceId = id;
  }
  public setCityId(id: number) {
    this.cityId = id;
  }

  public setPageNum(num: number) {
    this.pageNum = num;
  }

  public setPageSize(size: number) {
    this.pageSize = size;
  }

  @autobind
  public search() {
    window.scrollTo(0, 0);
    return this.daoService
      .getContestList({
        activityType: +this.activityType,
        activityId: this.activityId,
        contestId: this.contestId,
        provinceId: this.provinceId,
        cityId: this.cityId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        showBrandSign: SHOW_BRAND,
      })
      .then(res => {
        this.activityList = res.list || [];
        this.total = res.total;
      });
  }

  public resetSearch() {
    this.setPageNum(1);
    this.setPageSize(6);
    this.search();
  }

  public getAreaList() {
    return this.daoService.getAreaList().then(res => {
      this.areaList = this.removeEmptyChildren(res);
    });
  }

  public removeEmptyChildren(list: AreaList) {
    return list.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          item.children = undefined;
        } else {
          item.children = this.removeEmptyChildren(item.children);
        }
      }
      return item;
    });
  }

  public initBannerImage() {
    return this.daoService
      .getHomeBanner4ActivityType(+this.activityType, this.activityId)
      .then(res => {
        this.bannerImage = res.banner;
      });
  }

  public initActivityTypeList() {
    return this.daoService.getActivityType(SHOW_BRAND).then(res => {
      res = res.filter(item => [1, 3].includes(item.code));
      if (res && res.length) {
        this.activityTypeList = res;
        this.activityType = res[0].code;
      } else {
        this.activityTypeList = [];
      }
    });
  }

  public init() {
    if (this.isActivityList) {
      this.initActivityTypeList().then(() => {
        if (this.activityType) {
          this.bannerImage = ActivityDefaultBannerImage;
          this.resetSearch();
        }
      });
    } else {
      this.initBannerImage();
      this.resetSearch();
    }
  }

  public getActivityInfo() {
    this.daoService
      .getActivityInfo({
        activityId: this.activityId,
      })
      .then(res => {
        EventBusItemDetail.emit('item-new', res);
      });
  }
}
